// extracted by mini-css-extract-plugin
module.exports = {"housing_map_section":"housing-map_housing_map_section__1AfRm","map_container":"housing-map_map_container__ATEss","marker":"housing-map_marker__3-lqK"};